import Vue from "vue";
import Router from "vue-router";
import { buildChangGanNaoOAuthUrl } from "@/utils/changGanNaoOAuth";
import { isTaikangStaffMode, isTaikangStaffSession } from "@/utils/sanGaoStaffMode";
import {
  getJiaJiHuaStaffOrganizationId,
  isJiaJiHuaCombinedOrganization,
} from "@/utils/jiaJiHuaStaffScope";
import {
  isTaikangSalesmanMode,
  isTaikangSalesmanSession,
  getSanGaoSalesmanSessionOrgId,
  clearSanGaoSalesmanSession,
} from "@/utils/sanGaoSalesmanMode";

Vue.use(Router);
import Home from "@/views/home";
import MiddlePage from "@/views/middle";
import Login from "@/views/login";
import Login2 from "@/views/login/index2";
import Rights from "@/views/rights";
import RightsCode from "@/views/rights/indexCode";
import RightsActive from "@/views/rights/active";
import RightsPerson from "@/views/rights/person";
import RightsPersonNew from "@/views/newViews/rights/person";
import RightsDistribute from "@/views/newViews/rights/distribute";
import RightsPersonAddNew from "@/views/newViews/rights/personAddNew";
import RightsPersonAdd from "@/views/rights/personAdd";
import RightsPersonList from "@/views/rights/personList";
import RightsDetail from "@/views/rights/detail";
import showPdf from "@/views/pdf";
import ProductShow from "@/views/rights/productShow";
import ProgressComponent from "@/views/progress";
import ProgressComponent2 from "@/views/progress/step2";
import ProgressComponent2Base from "@/views/progress/step2Base";
import ProgressComponent2GP96 from "@/views/progress/step2GP96";
import ProgressComponent3 from "@/views/progress/step3";
import ProgressComponent3Base from "@/views/progress/step3Base";
import ProgressComponent4 from "@/views/progress/step4";
import AppointmentDetail from "@/views/appointment/detail";
import AppointmentList from "@/views/appointment/list";
import Personal from "@/views/personal";
import PersonalNew from "@/views/personalNew";
import jump1 from "@/views/personalNew/jump1";
import jump2 from "@/views/personalNew/jump2";
import jump3 from "@/views/personalNew/jump3";
import jump4 from "@/views/personalNew/jump4";
import Content1 from "@/views/content/content1";
import Content2 from "@/views/content/content2";
import serverPdfBase from "@/views/content/serverPdfBase";
import serverPdfPlus from "@/views/content/serverPdfPlus";
import serverPdfDrug from "@/views/content/serverPdfDrug";
import serverPdfBasePlus from "@/views/content/serverPdfBasePlus";
import settleIndex from "@/views/settle/index";
import settlePdmIndex from "@/views/settle/pdmIndex";
import settleOnlyIndex from "@/views/settle/indexOnly";
import settleOnlyIndexYL from "@/views/settle/indexOnlyYL";

import settleInfo from "@/views/settleInfo";
import settleInfoSuccess from "@/views/settleInfo/success";

import settleInfoYuanJiTang from "@/views/settleInfo/yuanjitang";

import longHuShanInfo from "@/views/longHuShan";
import longHuShanInfoSuccess from "@/views/longHuShan/success";
import huaDaInfo from "@/views/huaDa";
import huaDaInfoSuccess from "@/views/huaDa/success";
import huaDaSuInfo from "@/views/huaDaSu";
import huaDaVipInfo from "@/views/huaDaVip";

import collegeInfo from "@/views/college";
import collegeInfoSuccess from "@/views/college/success";

import huaDaInfoTiYan from "@/views/huaDaTiYan";
import huaDaInfoSuccessTiYan from "@/views/huaDaTiYan/success";
import sanGaoInfo from "@/views/sanGao";
import sanGaoPay from "@/views/sanGao/pay";
import sanGaoDaoHuiLiAmount from "@/views/sanGao/amount";

import shuLanInfo from "@/views/shuLan";
import changGanNaoInfo from "@/views/changGanNao";
import shuLanInfoSuccess from "@/views/shuLan/success";
import shuLanDaoHuiLiInfo from "@/views/shuLanDaoHuiLi";
import shuLanDaoHuiLiInfoSuccess from "@/views/shuLanDaoHuiLi/success";

import paysuccess from "@/views/settle/paysuccess";
import alertUpdate from "@/views/settle/alertUpdate";
import meetingIndex from "@/views/meeting/index";
import meetingSuccess from "@/views/meeting/success";
import payWxAlert from "@/views/settle/payWxAlert";

import LoginNew from "@/views/loginNew";
import { isWehat, onLogin } from "./util";

const routes = [
  // {
  //   path: '/',
  //   meta: {
  //     title: '个人中心',
  //   },
  //   redirect: '/personal'
  // },
  {
    path: "/middle",
    name: "middle",
    component: MiddlePage,
  },
  // {
  //   path: '/login',
  //   component: Login
  // },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: Login2,
  },
  {
    path: "/loginNew",
    name: "loginNew",
    meta: {
      title: "登录",
    },
    component: LoginNew,
  },
  {
    path: "/rights",
    name: "rights",
    meta: {
      title: "权益激活",
    },
    component: Rights,
  },
  {
    path: "/rightsCode",
    name: "rightsCode",
    meta: {
      title: "权益激活",
    },
    component: RightsCode,
  },
  {
    path: "/rightsActive",
    name: "rightsActive",
    meta: {
      title: "权益激活",
    },
    component: RightsActive,
  },
  {
    path: "/rightsPerson",
    name: "rightsPerson",
    meta: {
      title: "我的权益",
    },
    component: RightsPerson,
  },
  {
    path: "/rightsPersonNew",
    name: "rightsPersonNew",
    meta: {
      title: "我的权益",
    },
    component: RightsPersonNew,
  },
  {
    path: "/rightsDistribute",
    name: "rightsDistribute",
    meta: {
      title: "分配详情",
    },
    component: RightsDistribute,
  },
  {
    path: "/rightsPersonAdd",
    name: "rightsPersonAdd",
    meta: {
      title: "添加家人",
    },
    component: RightsPersonAdd,
  },
  {
    path: "/rightsPersonAddNew",
    name: "rightsPersonAddNew",
    meta: {
      title: "添加成员",
    },
    component: RightsPersonAddNew,
  },
  {
    path: "/rightsPersonList",
    name: "rightsPersonList",
    meta: {
      title: "我的卡包",
    },
    component: RightsPersonList,
  },
  {
    path: "/rightsDetail",
    name: "rightsDetail",
    meta: {
      title: "权益详情",
    },
    component: RightsDetail,
  },
  {
    path: "/progress",
    name: "progress",
    meta: {
      title: "权益预约",
    },
    component: ProgressComponent,
  },
  {
    path: "/progressStep2",
    name: "progressStep2",
    meta: {
      title: "权益预约",
    },
    component: ProgressComponent2,
  },
  {
    path: "/progressStep2Base",
    name: "progressStep2Base",
    meta: {
      title: "权益预约",
    },
    component: ProgressComponent2Base,
  },
  {
    path: "/progressStep2GP96",
    name: "progressStep2GP96",
    meta: {
      title: "权益预约",
    },
    component: ProgressComponent2GP96,
  },
  {
    path: "/progressStep3",
    name: "progressStep3",
    meta: {
      title: "权益预约",
    },
    component: ProgressComponent3,
  },
  {
    path: "/progressStep3Base",
    name: "progressStep3Base",
    meta: {
      title: "权益预约",
    },
    component: ProgressComponent3Base,
  },
  {
    path: "/progressStep4",
    name: "progressStep4",
    meta: {
      title: "预约完成",
    },
    component: ProgressComponent4,
  },
  {
    path: "/appointmentDetail",
    name: "appointmentDetail",
    meta: {
      title: "预约完成",
    },
    component: AppointmentDetail,
  },
  {
    path: "/appointmentList",
    name: "appointmentList",
    meta: {
      title: "我的预约",
    },
    component: AppointmentList,
  },
  {
    path: "/personal",
    name: "personal",
    meta: {
      title: "个人中心",
    },
    component: Personal,
  },
  {
    path: "/personalNew",
    name: "personalNew",
    meta: {
      title: "个人中心",
    },
    component: PersonalNew,
  },
  {
    path: "/jump1",
    name: "jump1",
    meta: {
      title: "潘多姆",
    },
    component: jump1,
  },
  {
    path: "/jump2",
    name: "jump2",
    meta: {
      title: "潘多姆",
    },
    component: jump2,
  },
  {
    path: "/jump3",
    name: "jump3",
    meta: {
      title: "潘多姆",
    },
    component: jump3,
  },
  {
    path: "/jump4",
    name: "jump4",
    meta: {
      title: "潘多姆",
    },
    component: jump4,
  },
  {
    path: "/content1",
    name: "content1",
    meta: {
      title: "特药项目介绍",
    },
    component: Content1,
  },
  {
    path: "/content2",
    name: "content2",
    meta: {
      title: "国寿国药全面战略合作",
    },
    component: Content2,
  },
  {
    path: "/serverPdfBase",
    name: "serverPdfBase",
    meta: {
      title: "服务指南",
    },
    component: serverPdfBase,
  },
  {
    path: "/serverPdfDrug",
    name: "serverPdfDrug",
    meta: {
      title: "疾病清单",
    },
    component: serverPdfDrug,
  },
  {
    path: "/serverPdfBasePlus",
    name: "serverPdfBasePlus",
    meta: {
      title: "服务指南",
    },
    component: serverPdfBasePlus,
  },
  {
    path: "/serverPdfPlus",
    name: "serverPdfPlus",
    meta: {
      title: "服务指南",
    },
    component: serverPdfPlus,
  },
  {
    path: "/productShow",
    name: "productShow",
    meta: {
      title: "特药权益介绍",
    },
    component: ProductShow,
  },
  {
    path: "/showPdf",
    name: "showPdf",
    meta: {
      title: "特药权益介绍",
    },
    component: showPdf,
  },
  {
    path: "/payWxAlert",
    name: "payWxAlert",
    meta: {
      title: "支付提示",
    },
    component: payWxAlert,
  },

  {
    path: "/settleIndex",
    name: "settleIndex",
    meta: {
      title: "个人结算业务支付",
    },
    component: settleIndex,
  },
  {
    path: "/settlePdmIndex",
    name: "settlePdmIndex",
    meta: {
      title: "潘多姆健康管理",
    },
    component: settlePdmIndex,
  },
  {
    path: "/settleInfo",
    name: "settleInfo",
    meta: {
      title: "信息填写",
    },
    component: settleInfo,
  },
  {
    path: "/settleKeYangInfo",
    name: "settleKeYangInfo",
    meta: {
      title: "信息填写",
    },
    component: settleInfoYuanJiTang,
  },
  {
    path: "/longHuShanInfo",
    name: "longHuShanInfo",
    meta: {
      title: "至臻至纯祈福开运",
    },
    component: longHuShanInfo,
  },
  {
    path: "/longHuShanInfoSuccess",
    name: "longHuShanInfoSuccess",
    meta: {
      title: "支付结果",
    },
    component: longHuShanInfoSuccess,
  },
  {
    path: "/huaDaInfo",
    name: "huaDaInfo",
    meta: {
      title: "国家基因细胞焕活计划",
    },
    component: huaDaInfo,
  },
  {
    path: "/huaDaSuInfo",
    name: "huaDaSuInfo",
    meta: {
      title: "国家基因细胞焕活计划",
    },
    component: huaDaSuInfo,
  },
  {
    path: "/huaDaVipInfo",
    name: "huaDaVipInfo",
    meta: {
      title: "国家基因细胞焕活计划",
    },
    component: huaDaVipInfo,
  },
  
  {
    path: "/collegeInfo",
    name: "collegeInfo",
    meta: {
      title: "新未来健康工程",
    },
    component: collegeInfo,
  },
  {
    path: "/collegeInfoSuccess",
    name: "collegeInfoSuccess",
    meta: {
      title: "提交结果",
    },
    component: collegeInfoSuccess,
  },
  
  {
    path: "/huaDaInfoSuccess",
    name: "huaDaInfoSuccess",
    meta: {
      title: "支付结果",
    },
    component: huaDaInfoSuccess,
  },

  {
    path: "/huaDaInfoTiYan",
    name: "huaDaInfoTiYan",
    meta: {
      title: "国家基因细胞焕活计划-体验版",
    },
    component: huaDaInfoTiYan,
  },
  {
    path: "/huaDaInfoSuccessTiYan",
    name: "huaDaInfoSuccessTiYan",
    meta: {
      title: "支付结果",
    },
    component: huaDaInfoSuccessTiYan,
  },
  {
    path: "/sanGaoInfo",
    name: "sanGaoInfo",
    meta: {
      title: "三高修复",
    },
    component: sanGaoInfo,
    props: { giftMode: false },
  },
  {
    path: "/sanGaoInfoSuccess",
    name: "sanGaoInfoSuccess",
    meta: {
      title: "支付结果",
    },
    component: huaDaInfoSuccess,
  },
  {
    path: "/sanGaoDaoHuiLiInfo",
    name: "sanGaoDaoHuiLiInfo",
    meta: {
      title: "三高修复到会礼",
    },
    component: sanGaoInfo,
    props: { giftMode: true },
  },
  {
    path: "/sanGaoDaoHuiLiInfoSuccess",
    name: "sanGaoDaoHuiLiInfoSuccess",
    meta: {
      title: "支付结果",
    },
    component: huaDaInfoSuccessTiYan,
  },
  {
    path: "/sanGaoPay",
    name: "sanGaoPay",
    meta: {
      title: "三高修复·健康重启",
    },
    component: sanGaoPay,
  },
    {
        path: "/sanGaoDaoHuiLiSettle",
        name: "sanGaoDaoHuiLiSettle",
        meta: {
            title: "三高修复到会礼现场收款",
        },
        component: sanGaoDaoHuiLiAmount,
    },
  {
    path: "/sanGao/salesman/login",
    name: "SanGaoSalesmanLogin",
    component: () => import("@/views/sanGao/salesman/login"),
    meta: {
      title: "业务员注册/登录",
      requiresAuth: false,
      system: "san-gao-salesman",
      loginPath: "/sanGao/salesman/login",
      staffHomePath: "/sanGao/salesman/index",
    },
  },
  {
    path: "/sanGao/salesman/index",
    name: "SanGaoSalesmanIndex",
    component: () => import("@/views/sanGao/salesman/index"),
    meta: {
      title: "业务员工作台",
      requiresAuth: true,
      system: "san-gao-salesman",
      loginPath: "/sanGao/salesman/login",
      staffHomePath: "/sanGao/salesman/index",
    },
  },
  {
    path: "/sanGao/salesman/exam",
    name: "SanGaoSalesmanExam",
    component: () => import("@/views/sanGao/salesman/exam"),
    meta: {
      title: "体检预约",
      requiresAuth: true,
      system: "san-gao-salesman",
      loginPath: "/sanGao/salesman/login",
      staffHomePath: "/sanGao/salesman/index",
    },
  },
  {
    path: "/sanGao/salesman/payresult",
    name: "SanGaoSalesmanPayResult",
    component: () => import("@/views/sanGao/salesman/payresult"),
    meta: {
      title: "支付结果",
      requiresAuth: true,
      system: "san-gao-salesman",
      loginPath: "/sanGao/salesman/login",
      staffHomePath: "/sanGao/salesman/index",
    },
  },
  {
    path: "/sanGao/salesman/qrcode",
    name: "SanGaoSalesmanQrcode",
    component: () => import("@/views/sanGao/salesman/qrcode"),
    meta: {
      title: "分享问卷",
      requiresAuth: true,
      system: "san-gao-salesman",
      loginPath: "/sanGao/salesman/login",
      staffHomePath: "/sanGao/salesman/index",
    },
  },
  {
    path: "/sanGao/salesman/officialAccount",
    name: "SanGaoSalesmanOfficialAccount",
    component: () => import("@/views/sanGao/salesman/officialAccount"),
    meta: {
      title: "关注公众号",
      requiresAuth: true,
      system: "san-gao-salesman",
      loginPath: "/sanGao/salesman/login",
      staffHomePath: "/sanGao/salesman/index",
    },
  },

  {
    path: "/sanGao/staff/login",
    name: "SanGaoStaffLogin",
    component: () => import("@/views/sanGao/staff/login"),
    meta: {
      title: "内勤登录",
      requiresAuth: false,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/login",
      staffHomePath: "/sanGao/staff/index",
    },
  },
  {
    path: "/sanGao/staff/index",
    name: "SanGaoStaffIndex",
    component: () => import("@/views/sanGao/staff/index"),
    meta: {
      title: "内勤工作台",
      requiresAuth: true,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/login",
      staffHomePath: "/sanGao/staff/index",
    },
  },
  {
    path: "/sanGao/staff/detail",
    name: "SanGaoStaffCustomerDetail",
    component: () => import("@/views/sanGao/staff/detail"),
    meta: {
      title: "客户问卷详情",
      requiresAuth: true,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/login",
      staffHomePath: "/sanGao/staff/index",
    },
  },
  {
    path: "/sanGao/staff/salesmanQrcode",
    name: "SanGaoStaffSalesmanQrcode",
    component: () => import("@/views/sanGao/staff/salesmanQrcode"),
    meta: {
      title: "业务员注册二维码",
      requiresAuth: true,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/login",
      staffHomePath: "/sanGao/staff/index",
    },
  },

  {
    path: "/sanGao/staff/pc",
    redirect: "/sanGao/staff/pc/guide",
  },
  {
    path: "/sanGao/staff/pc/guide",
    name: "SanGaoStaffPcGuide",
    component: () => import("@/views/sanGao/staff/pc/guide"),
    meta: {
      title: "使用引导",
      requiresAuth: false,
      ignoreToken: true,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/pc/login",
      staffHomePath: "/sanGao/staff/pc/index",
    },
  },
  {
    path: "/sanGao/staff/pc/login",
    name: "SanGaoStaffPcLogin",
    component: () => import("@/views/sanGao/staff/pc/login"),
    meta: {
      title: "内勤登录",
      requiresAuth: false,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/pc/login",
      staffHomePath: "/sanGao/staff/pc/index",
    },
  },
  {
    path: "/sanGao/staff/pc/index",
    name: "SanGaoStaffPcIndex",
    component: () => import("@/views/sanGao/staff/pc/index"),
    meta: {
      title: "内勤工作台",
      requiresAuth: true,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/pc/login",
      staffHomePath: "/sanGao/staff/pc/index",
    },
  },
  {
    path: "/sanGao/staff/pc/detail",
    name: "SanGaoStaffPcCustomerDetail",
    component: () => import("@/views/sanGao/staff/pc/detail"),
    meta: {
      title: "客户问卷详情",
      requiresAuth: true,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/pc/login",
      staffHomePath: "/sanGao/staff/pc/index",
    },
  },
  {
    path: "/sanGao/staff/pc/salesmanQrcode",
    name: "SanGaoStaffPcSalesmanQrcode",
    component: () => import("@/views/sanGao/staff/pc/salesmanQrcode"),
    meta: {
      title: "业务员注册二维码",
      requiresAuth: true,
      system: "san-gao-staff",
      loginPath: "/sanGao/staff/pc/login",
      staffHomePath: "/sanGao/staff/pc/index",
    },
  },

  {
    path: "/changGanNaoInfo",
    name: "changGanNaoInfo",
    meta: { title: "肠肝脑养护" },
    component: changGanNaoInfo,
  },
  {
    path: "/changGanNaoInfoSuccess",
    name: "changGanNaoInfoSuccess",
    meta: { title: "支付结果" },
    component: shuLanInfoSuccess,
  },
  {
    path: "/shuLanInfo",
    name: "shuLanInfo",
    meta: {
      title: "樹蘭醫療",
    },
    component: shuLanInfo,
  },
  {
    path: "/shuLanInfoSuccess",
    name: "shuLanInfoSuccess",
    meta: {
      title: "支付结果",
    },
    component: shuLanInfoSuccess,
  },
  {
    path: "/shuLanDaoHuiLiInfo",
    name: "shuLanDaoHuiLiInfo",
    meta: {
      title: "樹蘭醫療-到会礼",
    },
    component: shuLanDaoHuiLiInfo,
  },
  {
    path: "/shuLanDaoHuiLiInfoSuccess",
    name: "shuLanDaoHuiLiInfoSuccess",
    meta: {
      title: "支付结果",
    },
    component: shuLanDaoHuiLiInfoSuccess,
  },

  {
    path: "/settleInfoSuccess",
    name: "settleInfoSuccess",
    meta: {
      title: "支付结果",
    },
    component: settleInfoSuccess,
  },
  {
    path: "/settleOnlyIndex",
    name: "settleOnlyIndex",
    meta: {
      title: "个人结算业务支付",
    },
    component: settleOnlyIndex,
  },
  {
    path: "/settleOnlyIndexYL",
    name: "settleOnlyIndexYL",
    meta: {
      title: "个人结算业务支付",
    },
    component: settleOnlyIndexYL,
  },

  {
    path: "/paysuccess",
    name: "paysuccess",
    meta: {
      title: "支付结果",
    },
    component: paysuccess,
  },
  {
    path: "/alertUpdate",
    name: "alertUpdate",
    meta: {
      title: "系统升级中",
    },
    component: alertUpdate,
  },
  {
    path: "/meetingReport",
    name: "meetingReport",
    meta: {
      title: "参会登记",
    },
    component: meetingIndex,
  },
  {
    path: "/meetingSuccess",
    name: "meetingSuccess",
    meta: {
      title: "参会登记成功",
    },
    component: meetingSuccess,
  },

  {
    path: "*",
    redirect: "/personal",
  },
  // 医大系统路由
  {
    path: '/medical-university/login',
    name: 'MedicalUniversityLogin',
    component: () => import('@/views/medicalUniversity/login'),
    meta: {
      title: '医大系统登录',
      requiresAuth: false,
      system: 'medical-university'
    }
  },
  {
    path: '/medical-university',
    name: 'MedicalUniversityIndex',
    component: () => import('@/views/medicalUniversity/index'),
    meta: {
      title: '首页',
      requiresAuth: true,
      system: 'medical-university'
    }
  },
  {
    path: '/medical-university/customers',
    name: 'MedicalUniversityCustomerList',
    component: () => import('@/views/medicalUniversity/customerList'),
    meta: {
      title: '客户列表',
      requiresAuth: true,
      system: 'medical-university'
    }
  },
  {
    path: '/medical-university/customers/:id',
    name: 'MedicalUniversityCustomerDetail',
    component: () => import('@/views/medicalUniversity/customerDetail'),
    meta: {
      title: '客户详情',
      requiresAuth: true,
      system: 'medical-university'
    }
  },
  {
    path: '/medical-university/statistics',
    name: 'MedicalUniversityStatisticsList',
    component: () => import('@/views/medicalUniversity/statisticsList'),
    meta: {
      title: '数据统计',
      requiresAuth: true,
      system: 'medical-university'
    }
  },
  {
    path: '/medical-university/statistics/:id',
    name: 'MedicalUniversityStatisticsDetail',
    component: () => import('@/views/medicalUniversity/statisticsDetail'),
    meta: {
      title: '客户详情',
      requiresAuth: true,
      system: 'medical-university'
    }
  },
  {
    path: '/medical-university/mailing',
    name: 'MedicalUniversityMailing',
    component: () => import('@/views/medicalUniversity/mailing'),
    meta: {
      title: '邮寄列表',
      requiresAuth: true,
      system: 'medical-university'
    }
  },
  // 客户端系统路由
  {
    path: '/client/login',
    name: 'ClientLogin',
    component: () => import('@/views/client/login'),
    meta: {
      title: '客户端登录',
      requiresAuth: false,
      system: 'client'
    }
  },
  {
    path: '/client',
    name: 'ClientIndex',
    component: () => import('@/views/client/index'),
    meta: {
      title: '客户端首页',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/rights',
    name: 'ClientRights',
    component: () => import('@/views/client/rights'),
    meta: {
      title: '权益详情',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/rightsDetail',
    name: 'ClientRightsDetail',
    component: () => import('@/views/client/rightsDetail'),
    meta: {
      title: '查看权益',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/certificate',
    name: 'ClientCertificate',
    component: () => import('@/views/client/certificate'),
    meta: {
      title: '证书查询',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/realtime',
    name: 'ClientRealtime',
    component: () => import('@/views/client/realtime'),
    meta: {
      title: '实时查看',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/realtime-menu',
    name: 'ClientRealtimeMenu',
    component: () => import('@/views/client/realtimeMenu'),
    meta: {
      title: '实时查看',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/video-list',
    name: 'ClientVideoList',
    component: () => import('@/views/client/videoList'),
    meta: {
      title: '历史视频',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/video-player',
    name: 'ClientVideoPlayer',
    component: () => import('@/views/client/videoPlayer'),
    meta: {
      title: '视频播放',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/client/consent',
    name: 'ClientConsent',
    component: () => import('@/views/client/consent'),
    meta: {
      title: '知情同意书',
      requiresAuth: true,
      system: 'client'
    }
  },
  {
    path: '/jiaJiHua/login',
    name: 'JiaJiHuaLogin',
    component: () => import('@/views/jiaJiHua/client/login'),
    meta: {
      title: '甲基化登录',
      requiresAuth: false,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua',
      staffHomePath: '/jiaJiHua/medical-university'
    }
  },
  {
    path: '/jiaJiHua/collegeInfo',
    name: 'JiaJiHuaCollegeInfo',
    component: () => import('@/views/jiaJiHua/college'),
    meta: {
      title: '甲基化',
      productId: '18'
    }
  },
  {
    path: '/jiaJiHua/collegeSalivaInfo',
    name: 'JiaJiHuaCollegeSalivaInfo',
    component: () => import('@/views/jiaJiHua/college/saliva'),
    meta: {
      title: '甲基化三癌早筛采样',
      productId: '18'
    }
  },
  {
    path: '/jiaJiHua/collegeInfoSuccess',
    name: 'JiaJiHuaCollegeInfoSuccess',
    component: () => import('@/views/jiaJiHua/college/success'),
    meta: {
      title: '提交结果',
      productId: '18'
    }
  },
  {
    path: '/jiaJiHua',
    name: 'JiaJiHuaClientIndex',
    component: () => import('@/views/jiaJiHua/client/index'),
    meta: {
      title: '甲基化首页',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/rights',
    name: 'JiaJiHuaClientRights',
    component: () => import('@/views/jiaJiHua/client/rights'),
    meta: {
      title: '权益详情',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/rightsDetail',
    name: 'JiaJiHuaClientRightsDetail',
    component: () => import('@/views/jiaJiHua/client/rightsDetail'),
    meta: {
      title: '查看权益',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/certificate',
    name: 'JiaJiHuaClientCertificate',
    component: () => import('@/views/jiaJiHua/client/certificate'),
    meta: {
      title: '证书查询',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/realtime',
    name: 'JiaJiHuaClientRealtime',
    component: () => import('@/views/jiaJiHua/client/realtime'),
    meta: {
      title: '实时查看',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/realtime-menu',
    name: 'JiaJiHuaClientRealtimeMenu',
    component: () => import('@/views/jiaJiHua/client/realtimeMenu'),
    meta: {
      title: '实时查看',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/video-list',
    name: 'JiaJiHuaClientVideoList',
    component: () => import('@/views/jiaJiHua/client/videoList'),
    meta: {
      title: '历史视频',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/video-player',
    name: 'JiaJiHuaClientVideoPlayer',
    component: () => import('@/views/jiaJiHua/client/videoPlayer'),
    meta: {
      title: '视频播放',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/consent',
    name: 'JiaJiHuaClientConsent',
    component: () => import('@/views/jiaJiHua/client/consent'),
    meta: {
      title: '知情同意书',
      requiresAuth: true,
      system: 'client',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      clientHomePath: '/jiaJiHua'
    }
  },
  {
    path: '/jiaJiHua/medical-university',
    name: 'JiaJiHuaMedicalUniversityIndex',
    component: () => import('@/views/jiaJiHua/medicalUniversity/index'),
    meta: {
      title: '首页',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university'
    }
  },
  {
    path: '/jiaJiHua/medical-university/customers',
    name: 'JiaJiHuaMedicalUniversityCustomerList',
    component: () => import('@/views/jiaJiHua/medicalUniversity/customerList'),
    meta: {
      title: '客户列表',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university'
    }
  },
  {
    path: '/jiaJiHua/medical-university/combined/customers',
    name: 'JiaJiHuaCombinedCustomerList',
    component: () => import('@/views/jiaJiHua/medicalUniversity/combined/customerList'),
    meta: {
      title: '检测客户列表',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university',
      combinedSamples: true,
    }
  },
  {
    path: '/jiaJiHua/medical-university/combined/customers/:id',
    name: 'JiaJiHuaCombinedCustomerDetail',
    component: () => import('@/views/jiaJiHua/medicalUniversity/combined/customerDetail'),
    meta: {
      title: '客户详情',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university',
      combinedSamples: true,
    }
  },
  {
    path: '/jiaJiHua/medical-university/combined/mailing',
    name: 'JiaJiHuaCombinedMailing',
    component: () => import('@/views/jiaJiHua/medicalUniversity/combined/mailing'),
    meta: {
      title: '样品邮寄',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university',
      combinedSamples: true,
    }
  },
  {
    path: '/jiaJiHua/medical-university/customers/:id',
    name: 'JiaJiHuaMedicalUniversityCustomerDetail',
    component: () => import('@/views/jiaJiHua/medicalUniversity/customerDetail'),
    meta: {
      title: '客户详情',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university'
    }
  },
  {
    path: '/jiaJiHua/medical-university/statistics',
    name: 'JiaJiHuaMedicalUniversityStatisticsList',
    component: () => import('@/views/jiaJiHua/medicalUniversity/statisticsList'),
    meta: {
      title: '数据统计',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university'
    }
  },
  {
    path: '/jiaJiHua/medical-university/statistics/:id',
    name: 'JiaJiHuaMedicalUniversityStatisticsDetail',
    component: () => import('@/views/jiaJiHua/medicalUniversity/statisticsDetail'),
    meta: {
      title: '客户详情',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university'
    }
  },
  {
    path: '/jiaJiHua/medical-university/mailing',
    name: 'JiaJiHuaMedicalUniversityMailing',
    component: () => import('@/views/jiaJiHua/medicalUniversity/mailing'),
    meta: {
      title: '邮寄列表',
      requiresAuth: true,
      system: 'medical-university',
      productId: '18',
      loginPath: '/jiaJiHua/login',
      staffHomePath: '/jiaJiHua/medical-university'
    }
  },
  // {
  //   name: 'user',
  //   component: () => import('../views/user'),
  //   meta: {
  //     title: '会员中心'
  //   }
  // },
  // {
  //   name: 'cart',
  //   component: () => import('../views/cart'),
  //   meta: {
  //     title: '购物车'
  //   }
  // },
  // {
  //   name: 'goods',
  //   component: () => import('../views/goods'),
  //   meta: {
  //     title: '商品详情'
  //   }
  // }
  // mall H5 免登录页
  {
    path: "/h5/mall/list",
    name: "mallList",
    component: () => import("@/views/mall/list"),
    meta: { requiresAuth: false }
  },
  {
    path: "/h5/mall/detail",
    name: "mallDetail",
    component: () => import("@/views/mall/detail"),
    meta: { requiresAuth: false }
  },
  {
    path: "/h5/mall/cart",
    name: "mallCart",
    component: () => import("@/views/mall/cart"),
    meta: { requiresAuth: false }
  },
  {
    path: "/h5/mall/checkout",
    name: "mallCheckout",
    component: () => import("@/views/mall/checkout"),
    meta: { requiresAuth: false }
  },
  {
    path: "/h5/mall/payresult",
    name: "mallPayresult",
    component: () => import("@/views/mall/payresult"),
    meta: { requiresAuth: false }
  },
  {
    path: "/h5/mall/offlineResult",
    name: "mallOfflineResult",
    component: () => import("@/views/mall/offlineResult"),
    meta: { requiresAuth: false }
  },
  {
    path: "/h5/mall/inquiry",
    name: "mallInquiry",
    component: () => import("@/views/mall/inquiry"),
    meta: { requiresAuth: false }
  },
  {
    path: "/h5/mall/orderDetail",
    name: "mallOrderDetail",
    component: () => import("@/views/mall/orderDetail"),
    meta: { requiresAuth: false }
  }
];

// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

  // mall H5 免登录页,不走主系统OAuth与登录校验
  if (to.path.indexOf('/h5/mall/') === 0) {
    next();
    return;
  }

  // 三高业务员子系统：独立于主系统 OAuth/checkAuth，微信 code 仅用于支付 openid。
  // 首次进入 /?url=sanGao/salesman/... （无 code）：直接跳，页面内 ensureWxCode 负责 OAuth
  // 回跳 /?url=sanGao/salesman/...&code=xxx：存 code 到独立 key，跳回业务员页面
  // url 可能带或不带前导 /（ensureWxCode 用 fullPath.slice(1) 去掉了），此处统一归一化
  // 兼容主系统 OAuth 可能造成的 url 双重嵌套：?url=/sanGao/salesman/...
  if (
    to.path === "/" &&
    to.query.url &&
    to.query.url.indexOf("sanGao/salesman/") >= 0
  ) {
    console.log("[sanGao-salesman] 拦截 OAuth 回跳, url:", to.query.url, "code:", to.query.code);
    if (to.query.code) {
      localStorage.setItem("san_gao_salesman_code", to.query.code);
    }
    let target = to.query.url;
    if (target.indexOf("?url=") === 0) {
      target = target.slice(5);
    }
    if (target.indexOf("/") !== 0) {
      target = "/" + target;
    }
    next(target);
    return;
  }

  // if (['/settleInfo', '/settleInfoSuccess'].includes(to.path)) {
  //   next();
  //   return;
  // }

  // const query = this.$route.query;
  const query = to.query;
  let publicType = localStorage.getItem("publicType");

  publicType = query.publicType || publicType || "3"; // 1 - 现有逻辑， 2 - 带有家庭版逻辑
  localStorage.setItem("publicType", publicType);
  
  let _productId = localStorage.getItem("productId");
  const metaProductId = to.meta && to.meta.productId;
  _productId = metaProductId || query.productId || _productId || "0";
  if (metaProductId && query.productId !== metaProductId) {
    next({
      path: to.path,
      query: {
        ...query,
        productId: metaProductId,
      },
      replace: true,
    })
    return;
  }
  if (metaProductId || query.productId) {
    localStorage.setItem("productId", _productId);
  } else {
    localStorage.removeItem('productId')
  }

  const isJiaJiHuaPath = to.path.indexOf('/jiaJiHua') === 0;

  // 医大系统权限检查
  if (to.meta && to.meta.system === 'medical-university') {
    const token = localStorage.getItem('medical_university_token');
    
    // 如果路由需要认证但用户未登录
    if (to.meta.requiresAuth && !token) {
      next({ path: to.meta.loginPath || '/medical-university/login', query: to.query })

      return;
    }

    // 如果用户已登录但访问登录页面，重定向到首页
    if (!to.meta.requiresAuth && token) {
      next({ path: to.meta.staffHomePath || '/medical-university', query: to.query })

      return;
    }
    
    // 检查token是否有效
    if (token && to.meta.requiresAuth) {
      try {
        const userStr = localStorage.getItem('medical_university_user');
        if (!userStr) {
          // 用户信息丢失，清除token并重定向到登录页
          localStorage.removeItem('medical_university_token');
          next({ path: to.meta.loginPath || '/medical-university/login', query: to.query })
          return;
        }
      } catch (error) {
        console.error('医大系统Token验证失败:', error);
        localStorage.removeItem('medical_university_token');
        localStorage.removeItem('medical_university_user');
        next({ path: to.meta.loginPath || '/medical-university/login', query: to.query })
        return;
      }
    }
    
    if (isJiaJiHuaPath && to.meta.requiresAuth) {
      const orgId = getJiaJiHuaStaffOrganizationId(to.query);
      const combinedOrganization = isJiaJiHuaCombinedOrganization(orgId);
      const combinedPrefix = '/jiaJiHua/medical-university/combined';
      const ordinaryPrefix = '/jiaJiHua/medical-university';
      const ordinaryList = to.path === `${ordinaryPrefix}/customers`;
      const ordinaryMailing = to.path === `${ordinaryPrefix}/mailing`;
      const ordinaryDetail = /^\/jiaJiHua\/medical-university\/customers\/[^/]+$/.test(to.path);
      const combinedDetail = /^\/jiaJiHua\/medical-university\/combined\/customers\/[^/]+$/.test(to.path);
      const linkedOrgId = Number(to.query.orgId);

      // 机构切换后不能把旧样品 ID 带到新机构的详情页，直接返回当前机构列表。
      if ((ordinaryDetail || combinedDetail) && orgId && linkedOrgId && linkedOrgId !== orgId) {
        next({
          path: `${combinedOrganization ? combinedPrefix : ordinaryPrefix}/customers`,
          query: {
            productId: '18',
            orgId: String(orgId),
            type: combinedOrganization ? undefined : '1',
          },
          replace: true,
        });
        return;
      }

      // 旧收藏链接也进入独立合并页；普通机构不会使用新的页面或混合查询。
      if (combinedOrganization && (ordinaryList || ordinaryMailing || ordinaryDetail)) {
        const combinedQuery = { ...to.query, productId: '18', orgId: String(orgId) };
        if (!ordinaryDetail) {
          delete combinedQuery.type;
        }
        next({
          path: to.path.replace(ordinaryPrefix, combinedPrefix),
          query: combinedQuery,
          replace: true,
        });
        return;
      }
      if (to.meta.combinedSamples) {
        if (!combinedOrganization) {
          next({
            path: orgId
              ? (combinedDetail ? `${ordinaryPrefix}/customers` : to.path.replace(combinedPrefix, ordinaryPrefix))
              : ordinaryPrefix,
            query: {
              ...to.query,
              productId: '18',
              orgId: orgId ? String(orgId) : undefined,
              type: Number(to.query.type) === 2 ? '2' : '1',
            },
            replace: true,
          });
          return;
        }
        if (String(to.query.orgId || '') !== String(orgId)) {
          next({
            path: to.path,
            query: { ...to.query, productId: '18', orgId: String(orgId) },
            replace: true,
          });
          return;
        }
      }
    }

    // 医大系统路由检查完成，继续执行
    next();
    return;
  }

  // 客户端系统权限检查
  if (to.meta && to.meta.system === 'client') {
    const token = localStorage.getItem('client_token');
    
    // 如果路由需要认证但用户未登录
    if (to.meta.requiresAuth && !token) {
      next({ path: to.meta.loginPath || '/client/login', query: to.query })
      return;
    }

    // 如果用户已登录但访问登录页面，重定向到首页
    if (!to.meta.requiresAuth && token) {
      next({ path: to.meta.clientHomePath || '/client', query: to.query })
      return;
    }
    
    // 检查token是否有效
    if (token && to.meta.requiresAuth) {
      try {
        const userStr = localStorage.getItem('client_user');
        if (!userStr) {
          // 用户信息丢失，清除token并重定向到登录页
          localStorage.removeItem('client_token');
          next({ path: to.meta.loginPath || '/client/login', query: to.query })
          return;
        }
      } catch (error) {
        console.error('客户端系统Token验证失败:', error);
        localStorage.removeItem('client_token');
        localStorage.removeItem('client_user');
        next({ path: to.meta.loginPath || '/client/login', query: to.query })
        return;
      }
    }
    
    // 客户端系统路由检查完成，继续执行
    next();
    return;
  }

  // 三高修复业务员子系统：通过链接（带 orgId）进入，自带 token，与主系统微信OAuth/Token完全独立
  if (to.meta && to.meta.system === 'san-gao-salesman') {
    const fromSalesman = from.meta && from.meta.system === 'san-gao-salesman';
    const hasVersionParam = Object.prototype.hasOwnProperty.call(to.query, 'taikang');
    const sessionTaikangMode = isTaikangSalesmanSession();
    const taikangMode = hasVersionParam ? isTaikangSalesmanMode(to.query)
      : (fromSalesman && isTaikangSalesmanMode(from.query)) || sessionTaikangMode;
    let token = localStorage.getItem('san_gao_salesman_token');
    // 必须先读取原登录机构，不能先被新入口的 orgId 覆盖后再做比较。
    const sessionOrgId = token ? getSanGaoSalesmanSessionOrgId() : '';
    const requestedOrgId = to.query.orgId ? String(to.query.orgId) : '';
    const orgId = requestedOrgId
      || (fromSalesman && from.query.orgId ? String(from.query.orgId) : '') || sessionOrgId;
    if (token && (taikangMode !== sessionTaikangMode
      || (requestedOrgId && sessionOrgId && requestedOrgId !== sessionOrgId))) {
      // 普通登录不能跳过特殊入口的编码登录，也不能跨机构复用 token。
      clearSanGaoSalesmanSession();
      token = null;
    }
    const salesmanQuery = Object.assign({}, to.query);
    if (orgId) {
      salesmanQuery.orgId = orgId;
      localStorage.setItem('san_gao_salesman_orgId', orgId);
    }
    if (taikangMode) salesmanQuery.taikang = '1';
    // 微信 OAuth 直接回跳当前页面（redirect_uri = /sanGao/salesman/index?orgId=xxx），
    // code 在 to.query.code 中，存到独立 key 后清掉，防止落入主系统 OAuth/checkAuth
    if (to.query && to.query.code) {
      localStorage.setItem('san_gao_salesman_code', to.query.code);
      // 通过路由清除一次性 code，保持地址栏与 $route 一致，并继续执行登录校验。
      const cleanQuery = Object.assign({}, salesmanQuery);
      delete cleanQuery.code;
      delete cleanQuery.state;
      next({ path: to.path, query: cleanQuery, hash: to.hash, replace: true });
      return;
    }
    if ((taikangMode && !isTaikangSalesmanMode(to.query))
      || (orgId && String(to.query.orgId || '') !== orgId)) {
      next({ path: to.path, query: salesmanQuery, hash: to.hash, replace: true });
      return;
    }
    if (to.meta.requiresAuth && !token) {
      next({ path: to.meta.loginPath || '/sanGao/salesman/login', query: Object.assign({}, salesmanQuery, { type: 'login' }) });
      return;
    }
    if (!to.meta.requiresAuth && token) {
      next({ path: to.meta.staffHomePath || '/sanGao/salesman/index', query: salesmanQuery });
      return;
    }
    next();
    return;
  }

  // 三高体检内勤子系统：独立 token（san_gao_staff_token），与主系统微信OAuth/Token完全独立
  if (to.meta && to.meta.system === 'san-gao-staff') {
    const hasVersionParam = Object.prototype.hasOwnProperty.call(to.query, 'taikang');
    const sessionTaikangMode = isTaikangStaffSession();
    // 页面内旧跳转可能只带 path，在统一守卫中延续版本参数，涵盖返回、退出及设备重定向。
    // 明确传 taikang=0 可退出泰康入口，避免被已有会话重新切回泰康版。
    const taikangMode = hasVersionParam
      ? isTaikangStaffMode(to.query)
      : (from.meta && from.meta.system === 'san-gao-staff' && isTaikangStaffMode(from.query)) || sessionTaikangMode;
    if (localStorage.getItem('san_gao_staff_token') && taikangMode !== sessionTaikangMode) {
      // 不跨版本复用会话，尤其不能用普通机构 token 跳过泰康的机构编码校验。
      localStorage.removeItem('san_gao_staff_token');
      localStorage.removeItem('san_gao_staff_info');
    }
    const staffQuery = taikangMode ? Object.assign({}, to.query, { taikang: '1' }) : to.query;
    if (taikangMode && !isTaikangStaffMode(to.query)) {
      next({ path: to.path, query: staffQuery, hash: to.hash, replace: true });
      return;
    }
    // 设备自动跳转：PC 打开移动页 → 跳 PC 页；移动端打开 PC 页 → 跳移动页（路径一一对应）
    const isPcDevice = window.innerWidth >= 750;
    const isPcPath = to.path.indexOf('/sanGao/staff/pc/') === 0;
    if (taikangMode && to.path === '/sanGao/staff/pc/guide') {
      const staffBase = isPcDevice ? '/sanGao/staff/pc' : '/sanGao/staff';
      next({ path: staffBase + (localStorage.getItem('san_gao_staff_token') ? '/index' : '/login'), query: staffQuery, replace: true });
      return;
    }
    if (isPcDevice && !isPcPath) {
      // PC 首次进入登录页时先到使用引导页（引导页上有「进入内勤端」按钮去登录）
      if (to.path === '/sanGao/staff/login' && !taikangMode) {
        next({ path: '/sanGao/staff/pc/guide', query: staffQuery });
        return;
      }
      next({ path: '/sanGao/staff/pc' + to.path.slice('/sanGao/staff'.length), query: staffQuery });
      return;
    }
    if (!isPcDevice && isPcPath) {
      // PC 专属页面（如使用引导页）在移动端没有对应页面时，落到移动端登录页
      const mobilePath = to.path.replace('/sanGao/staff/pc', '/sanGao/staff');
      const knownMobile = ['/sanGao/staff/login', '/sanGao/staff/index', '/sanGao/staff/detail', '/sanGao/staff/salesmanQrcode'];
      next({ path: knownMobile.indexOf(mobilePath) > -1 ? mobilePath : '/sanGao/staff/login', query: staffQuery });
      return;
    }
    // PC 页面挂上 html.is-pc，固定根字号，保证 Vant 组件按正常尺寸渲染
    if (isPcPath) {
      document.documentElement.classList.add('is-pc');
    } else {
      document.documentElement.classList.remove('is-pc');
    }
    const token = localStorage.getItem('san_gao_staff_token');
    if (to.meta.requiresAuth && !token) {
      next({ path: to.meta.loginPath || '/sanGao/staff/login', query: staffQuery });
      return;
    }
    if (!to.meta.requiresAuth && token && !to.meta.ignoreToken) {
      next({ path: to.meta.staffHomePath || '/sanGao/staff/index', query: staffQuery });
      return;
    }
    next();
    return;
  }

  if (
    to.path == "/settleIndex" ||
    to.path == "/settlePdmIndex" ||
    to.path == "/settleInfo" ||
    to.path == "/settleKeYangInfo" ||
    to.path == "/longHuShanInfo" ||
    to.path == "/huaDaInfo" ||
    to.path == "/huaDaSuInfo" ||
    to.path == "/huaDaVipInfo" ||
    to.path == "/sanGaoInfo" ||
    to.path == "/sanGaoDaoHuiLiInfo" ||
    to.path == "/sanGaoDaoHuiLiSettle" ||
    to.path == "/sanGaoPay" ||
    
    to.path == "/collegeInfo" ||
    to.path == "/jiaJiHua/collegeInfo" ||
    to.path == "/jiaJiHua/collegeSalivaInfo" ||
    to.path == "/huaDaInfoTiYan" ||
    to.path == "/changGanNaoInfo" ||
    to.path == "/shuLanInfo" ||
    to.path == "/shuLanDaoHuiLiInfo" ||
    to.path == "/settleOnlyIndex" ||
    to.path == "/settleOnlyIndexYL"
  ) {
    if (to.path == "/sanGaoPay" && query.shareToken) {
      const previousShareToken = localStorage.getItem("sanGaoShareToken");
      if (previousShareToken !== query.shareToken) {
        localStorage.removeItem("code");
        localStorage.setItem("sanGaoShareToken", query.shareToken);
      }
    }
    if (query.payType != null) {
      localStorage.removeItem("code");
      localStorage.setItem("payType", query.payType);
    }
    if (query.orgId != null) {
      localStorage.setItem("orgId", query.orgId);
    }
    if (query.companyId != null) {
      localStorage.setItem("companyId", query.companyId);
    }
    if (query.areaCode != null) {
      localStorage.setItem("areaCode", query.areaCode);
    }
  }

  // 本地开发时允许直接预览新增收款页；生产环境仍保持原微信授权流程。
  if (
    process.env.NODE_ENV === "development" &&
    (to.path == "/sanGaoInfo" || to.path == "/sanGaoDaoHuiLiInfo"
      || to.path == "/sanGaoDaoHuiLiSettle" || to.path == "/sanGaoPay")
  ) {
    next();
    return;
  }

  let code = query.code || localStorage.getItem("code");
  let wechat = isWehat();
  let token = localStorage.getItem("token");
  let fPath = to.fullPath;
  fPath = fPath.slice(1);

  console.log("code===" + query.code);
  if (wechat) {
    // 安全网：sanGao 业务员 OAuth 回跳（/?url=sanGao/salesman/...&code=xxx）
    // 如果上面的专用拦截器漏了，这里兜住，避免落入主系统 checkAuth → /login
    if (query.url && query.url.indexOf("sanGao/salesman/") >= 0) {
      if (query.code) {
        localStorage.setItem("san_gao_salesman_code", query.code);
      }
      let target = query.url;
      if (target.indexOf("?url=") === 0) target = target.slice(5);
      if (target.indexOf("/") !== 0) target = "/" + target;
      next(target);
      return;
    }
    if (!code) {
      if (to.path === "/changGanNaoInfo") {
        window.location.href = buildChangGanNaoOAuthUrl(query);
        return;
      }
      //let httpUrl = 'http://www-test.healthmore.net';
      //let httpUrl = 'http://127.0.0.1:8080';
      let httpUrl = "https://yisheng.healthmore.net";
      let appId = "wxb0ea01d4fd25cc75"; // 1 - 生产环境
      //let appId = 'wxa8795af1a3a9ca7b'; //测试
      if (publicType == 1) {
        appId = "wxd11a986432bc5343"; // 2 生产
        //appId = 'wxa8795af1a3a9ca7b'; //测试
      }

      if (to.path === "/sanGaoInfo") {
        // 地区码扫码后的首次授权必须保留完整查询参数，不能只依赖浏览器缓存。
        const redirectUri = `${httpUrl}/?url=${encodeURIComponent(fPath)}`;
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
          redirectUri
        )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
        return;
      }

      // window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0a96e693da6da47b&redirect_uri=http://127.0.0.1:8081/?url=${encodeURI(fPath)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${httpUrl}?url=${encodeURI(
        fPath
      )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
    } else {
      localStorage.setItem("code", code);

      let fullPath = query.url || to.fullPath;
      console.log("fullPath", to.path);
      // 权益页，不拦截
      if (
        to.path == "/rights" ||
        to.path == "/content1" ||
        to.path == "/content2" ||
        to.path == "/productShow" ||
        to.path == "/settleIndex" ||
        to.path == "/settlePdmIndex" ||
        to.path == "/settleInfo" ||
        to.path == "/settleKeYangInfo" ||
        to.path == "/settleInfoSuccess" ||
        to.path == "/collegeInfoSuccess" ||
        to.path == "/jiaJiHua/collegeInfoSuccess" ||
        to.path == "/longHuShanInfo" ||
        to.path == "/longHuShanInfoSuccess" ||
        to.path == "/huaDaInfo" ||
        to.path == "/huaDaSuInfo" ||
        to.path == "/huaDaVipInfo" ||
        to.path == "/collegeInfo" ||
        to.path == "/jiaJiHua/collegeInfo" ||
        to.path == "/jiaJiHua/collegeSalivaInfo" ||
        to.path == "/huaDaInfoSuccess" ||
        to.path == "/huaDaInfoTiYan" ||
        to.path == "/huaDaInfoSuccessTiYan" ||
        to.path == "/sanGaoInfo" ||
        to.path == "/sanGaoInfoSuccess" ||
        to.path == "/sanGaoDaoHuiLiInfo" ||
        to.path == "/sanGaoDaoHuiLiInfoSuccess" ||
        to.path == "/sanGaoDaoHuiLiSettle" ||
        to.path == "/sanGaoPay" ||
        to.path == "/changGanNaoInfo" ||
        to.path == "/shuLanInfo" ||
        to.path == "/changGanNaoInfoSuccess" ||
        to.path == "/shuLanInfoSuccess" ||
        to.path == "/shuLanDaoHuiLiInfo" ||
        to.path == "/shuLanDaoHuiLiInfoSuccess" ||
        to.path == "/settleOnlyIndex" ||
        to.path == "/settleOnlyIndexYL" ||
        to.path == "/meetingReport" ||
        to.path == "/meetingSuccess" ||
        to.path == "/rightsCode" ||
        to.path == "/alertUpdate" ||
        to.path == "/paysuccess"
      ) {
        next();
        return;
      }

      let url = fullPath;
      if (to.query.code) {
        url = fullPath.replace("/personal?url=", "");
      }

      console.log("to", url);
      if (
        url.search(/rights\?/) > -1 ||
        url.search(/content1/) > -1 ||
        url.search(/content2/) > -1 ||
        url.search(/productShow\?/) > -1 ||
        url.search(/settleIndex\?/) > -1 ||
        url.search(/settlePdmIndex\?/) > -1 ||
        url.search(/settleInfo\?/) > -1 ||
        url.search(/settleKeYangInfo\?/) > -1 ||
        url.search(/settleInfoSuccess\?/) > -1 ||
        url.search(/longHuShanInfo\?/) > -1 ||
        url.search(/longHuShanInfoSuccess\?/) > -1 ||
        url.search(/huaDaInfo\?/) > -1 ||
        url.search(/huaDaSuInfo\?/) > -1 ||
        url.search(/huaDaVipInfo\?/) > -1 ||
        url.search(/changGanNaoInfo\?/) > -1 ||
        url.search(/changGanNaoInfoSuccess\?/) > -1 ||
        url.search(/shuLanInfo\?/) > -1 ||
        url.search(/shuLanDaoHuiLiInfo\?/) > -1 ||
        url.search(/shuLanDaoHuiLiInfoSuccess\?/) > -1 ||
        url.search(/shuLanInfoSuccess\?/) > -1 ||
        url.search(/collegeInfo\?/) > -1 ||
        url.search(/jiaJiHua\/collegeInfo\?/) > -1 ||
        url.search(/jiaJiHua\/collegeSalivaInfo\?/) > -1 ||
        url.search(/collegeInfoSuccess\?/) > -1 ||
        url.search(/jiaJiHua\/collegeInfoSuccess\?/) > -1 ||
        url.search(/huaDaInfoSuccess\?/) > -1 ||
        url.search(/huaDaInfoTiYan\?/) > -1 ||
        url.search(/huaDaInfoSuccessTiYan\?/) > -1 ||
        url.search(/sanGaoInfo\?/) > -1 ||
        url.search(/sanGaoInfoSuccess\?/) > -1 ||
        url.search(/sanGaoDaoHuiLiInfo\?/) > -1 ||
        url.search(/sanGaoDaoHuiLiInfoSuccess\?/) > -1 ||
        url.search(/sanGaoDaoHuiLiSettle\?/) > -1 ||
        url.search(/sanGaoPay\?/) > -1 ||
        url.search(/settleOnlyIndex\?/) > -1 ||
        url.search(/settleOnlyIndexYL\?/) > -1 ||
        url.search(/meetingReport\?/) > -1 ||
        url.search(/meetingSuccess/) > -1 ||
        url.search(/rightsCode\?/) > -1 ||
        url.search(/alertUpdate\?/) > -1 ||
        url.search(/paysuccess\?/) > -1
      ) {
        url = url.replace("&payType=0", "");
        console.log("进入", url);
        next({
          path: url,
        });
        return;
      }

      if (!token && to.name != "login" && to.name != "loginNew") {
        let url = "";
        console.log("code", code);
        const res = await onLogin(code, fullPath);
        if (res.code == 200) {
          localStorage.setItem("token", res.data.token);
          const loginUrl = localStorage.getItem("loginUrl");
          if (loginUrl == "/loginNew") {
            url = fullPath.replace("/personalNew?url=", "");
          } else {
            url = fullPath.replace("/personal?url=", "");
          }
        } else if (res.code == 1004) {
          // 1004 需要注册
          url = isJiaJiHuaPath ? "/jiaJiHua/login" : "/login";
          if (!isJiaJiHuaPath && publicType == 1) {
            url = "/loginNew";
          }
        }
        console.log(444);
        next({
          path: url,
        });
      }
      next();
    }
  } else {
    let fullPath1 = to.fullPath;
    console.log("fullpATH1", fullPath1);
    if (
      fullPath1.search(/\/jiaJiHua\/collegeInfo\?/) > -1 ||
      fullPath1.search(/\/jiaJiHua\/collegeSalivaInfo\?/) > -1 ||
      fullPath1.search(/\/jiaJiHua\/collegeInfoSuccess\?/) > -1
    ) {
      next();
      return;
    }
    let url1 = "";
    if (
      //fullPath1.search(/\/settleIndex\?/) > -1 ||
      fullPath1.search(/\/settlePdmIndex\?/) > -1 ||
      fullPath1.search(/settleInfo\?/) > -1 ||
      fullPath1.search(/settleKeYangInfo\?/) > -1 ||
      fullPath1.search(/settleInfoSuccess\?/) > -1 ||
      fullPath1.search(/collegeInfoSuccess\?/) > -1 ||
      fullPath1.search(/jiaJiHua\/collegeInfoSuccess\?/) > -1 ||
      fullPath1.search(/longHuShanInfo\?/) > -1 ||
      fullPath1.search(/longHuShanInfoSuccess\?/) > -1 ||
      fullPath1.search(/huaDaInfo\?/) > -1 ||
      fullPath1.search(/huaDaSuInfo\?/) > -1 ||
      fullPath1.search(/shuLanInfoSuccess\?/) > -1 ||
      fullPath1.search(/shuLanDaoHuiLiInfo\?/) > -1 ||
      fullPath1.search(/shuLanDaoHuiLiInfoSuccess\?/) > -1 ||
      fullPath1.search(/changGanNaoInfo\?/) > -1 ||
      fullPath1.search(/changGanNaoInfoSuccess\?/) > -1 ||
      fullPath1.search(/shuLanInfo\?/) > -1 ||

      //fullPath1.search(/huaDaVipInfo\?/) > -1 ||
      fullPath1.search(/collegeInfo\?/) > -1 ||
      fullPath1.search(/jiaJiHua\/collegeInfo\?/) > -1 ||
      fullPath1.search(/jiaJiHua\/collegeSalivaInfo\?/) > -1 ||
      fullPath1.search(/huaDaInfoSuccess\?/) > -1 ||
      //fullPath1.search(/sanGaoInfo\?/) > -1 ||
      //fullPath1.search(/sanGaoInfoSuccess\?/) > -1 ||
      //fullPath1.search(/sanGaoDaoHuiLiInfoSuccess\?/) > -1 ||
      //fullPath1.search(/sanGaoDaoHuiLiSettle\?/) > -1 ||
      //fullPath1.search(/sanGaoPay\?/) > -1 ||
      //fullPath1.search(/huaDaInfoTiYan\?/) > -1 ||
      fullPath1.search(/huaDaInfoSuccessTiYan\?/) > -1 ||
      fullPath1.search(/\/settleOnlyIndex\?/) > -1 ||
      fullPath1.search(/\/settleOnlyIndexYL\?/) > -1
    ) {
      url1 = "/payWxAlert";
      next({
        path: url1,
      });
      return;
    }

    if (!token && to.name != "login" && to.name != "loginNew" && to.name != "JiaJiHuaLogin") {
      let fullPath = to.fullPath;
      let url = "";
      localStorage.setItem("redirectUrl", fullPath);
      console.log("fullpATH", fullPath);
      if (
        fullPath.search(/\/rights\?/) > -1 ||
        fullPath.search(/\/content1/) > -1 ||
        fullPath.search(/\/content2/) > -1 ||
        fullPath.search(/\/productShow\?/) > -1 ||
        fullPath.search(/\/meetingReport\?/) > -1 ||
        fullPath.search(/\/meetingSuccess/) > -1 ||

        fullPath.search(/\/rightsCode\?/) > -1 ||
        fullPath.search(/\/alertUpdate\?/) > -1 ||
        fullPath.search(/\/paysuccess\?/) > -1 ||
        fullPath.search(/\/payWxAlert/) > -1 ||
        fullPath.search(/\/collegeInfo\?/) > -1 ||
        fullPath.search(/\/jiaJiHua\/collegeInfo\?/) > -1 ||
        fullPath.search(/\/jiaJiHua\/collegeSalivaInfo\?/) > -1
      ) {
        url = fullPath;
        console.log("4");
        next();
        return;
      } else {
        // 1004 需要注册
        // url = '/login';
        url = isJiaJiHuaPath ? "/jiaJiHua/login" : "/login";
        if (!isJiaJiHuaPath && publicType == 1) {
          url = "/loginNew";
        }
        console.log("5");
      }
      next({
        path: url,
      });
    }
    next();
  }
});
// router.beforeEach((to, from, next) => {
//   const title = to.meta && to.meta.title;
//   if (title) {
//     document.title = title;
//   }

//   next();
// });

export { router };
